import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      maxWidth: 861,
    },
    title: {
      ...theme.typography.semiBold16,
      fontWeight: theme.typography.fontWeightBold,
      color: COLORS.gray.black,
    },
    dialogContent: {
      padding: theme.spacing(7, 6, 3),
    },
    loaders: {
      margin: theme.spacing(1, 0, 8),
    },
    buttonClose: {
      color: COLORS.gray.gray30,
      textDecoration: 'underline',
      marginLeft: 'auto',
      display: 'block',
    },
  }),
  { name: 'AccountExtractionLoaderPopup' }
);
